import SkapaPanel, {
  type PanelAttributes,
  PanelBody,
  type PanelBodyAttributes,
  type PanelBodyProps,
  type PanelFooterAttributes,
  type PanelFooterProps,
  type PanelHeaderAttributes,
  type PanelHeaderProps,
  type PanelProps,
  PanelFooter as SkapaPanelFooter,
  PanelHeader as SkapaPanelHeader,
} from "@ingka/panel";

const Panel = (props: PanelProps & PanelAttributes) => {
  return (
    <SkapaPanel prefix="saleslead__" {...props}>
      {props.children}
    </SkapaPanel>
  );
};

const PanelHeader = (props: PanelHeaderProps & PanelHeaderAttributes) => {
  return (
    <SkapaPanelHeader prefix="saleslead__" {...props}>
      {props.children}
    </SkapaPanelHeader>
  );
};

const PanelFooter = (props: PanelFooterProps & PanelFooterAttributes) => {
  return (
    <SkapaPanelFooter prefix="saleslead__" {...props}>
      {props.children}
    </SkapaPanelFooter>
  );
};

export {
  Panel,
  PanelBody,
  PanelFooter,
  PanelHeader,
  type PanelBodyAttributes,
  type PanelBodyProps,
  type PanelFooterAttributes,
  type PanelFooterProps,
  type PanelHeaderAttributes,
  type PanelHeaderProps,
  type PanelProps,
};
